import { SearchOrder } from './search-order.enum';

/**
 * Http API search query model object
 */
export class SearchQuery {
  page!: number;
  pageSize!: number;
  order: SearchOrder = SearchOrder.Asc;
  orderBy!: string;

  /**
   * Backwards compatibility for ONE services
   */
  countItems!: boolean;

  static empty(): SearchQuery {
    const cloned = new SearchQuery();
    cloned.page = 1;
    cloned.pageSize = 10;
    return cloned;
  }

  normilizeString(value: string): string | null {
    if (value !== null && value === '') {
      return null;
    }

    return value;
  }

  clone(cloned: SearchQuery): SearchQuery {
    if (!cloned) {
      cloned = new SearchQuery();
    }

    cloned.countItems = this.countItems;
    cloned.page = this.page;
    cloned.pageSize = this.pageSize;
    cloned.order = this.order;
    cloned.orderBy = this.orderBy;

    return cloned;
  }
}
